$(document).ready(function(){
      var topswiper = new Swiper('.product-slider', {
       slidesPerView: 4,
       loop: 'true',
       paginationClickable: true,
       nextButton: '.swiper-button-next',
       prevButton: '.swiper-button-prev',
       spaceBetween: 14,
       breakpoints: {
           // when window width is <= 320px
           320: {
             slidesPerView: 2,
             spaceBetweenSlides: 10
         },
           // when window width is <= 480px
           480: {
             slidesPerView: 2,
             spaceBetweenSlides: 15
         },
           // when window width is <= 640px
           768: {
             slidesPerView: 3,
             spaceBetweenSlides: 15
         }
       }
      });
      var swiper = new Swiper('#home-slider', {
       pagination: '.swiper-pagination',
       nextButton: '.swiper-button-next',
       prevButton: '.swiper-button-prev',
       paginationClickable: true,
       spaceBetween: 30,
          autoplay: 2500,
          autoplayDisableOnInteraction: false,
       loop: true,
       centeredSlides: true
     });
    var swiper = new Swiper('#home-slider2', {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        paginationClickable: true,
        spaceBetween: 0,
        loop: true,
        centeredSlides: true
    });
    var swiper = new Swiper('#home-slider3', {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        paginationClickable: true,
        spaceBetween: 0,
        loop: true,
        centeredSlides: true
    });
    $('.search-toggle').click(function(event){
        event.preventDefault();
        $('.mobilesearch').stop(true, true).slideToggle('slow');
        $('.mobilesearch').toggleClass('open');
        $('.search-toggle i').toggleClass('fa-search');
        $('.search-toggle i').toggleClass('fa-close');
        if($('.mobilesearch').hasClass('open')){
          $('#LiveSearchmobile').focus();
        }else{
          $('#LiveSearchmobile').focusout();
        }
    });
    var clicky;
    $(document).mousedown(function(e) {
        clicky = $(e.target);
    });
    $(document).mouseup(function(e) {
        clicky = null;
    });

    $('.search-toggle-desktop').click(function(event){
        event.preventDefault();
        var parentForm = $(this).closest("form");

        if($('.desktopsearch').hasClass('active') &&  $('.desktopsearch #LiveSearch').val().length >= 1) {
          parentForm.submit();
          return false;
        }

        $(".search-toggle-desktop").toggleClass('btn btn-primary');
        $('#LiveSearch').focus();

        $(".desktopsearch").toggleClass('active');
    });

    $('#LiveSearch').focusout(function(event){
      if(!$(clicky).hasClass('search-toggle-desktop') && !$(clicky).parents('.search-toggle-desktop').length){
        if($('#LiveSearch').val().length < 1){
          $(".desktopsearch").removeClass('active');
          $(".search-toggle-desktop").removeClass('btn btn-primary');
        }
      }
    });

    // UNVEIL
    $("img").unveil(200, function() {
      $(this).load(function() {
        var classes = this.getAttribute('class');
        this.setAttribute("class", classes +' loaded');
      });
    });

    //Livesearch
    $('#LiveSearch').keyup(function(event) {
      if($(this).val().length >= 1){
        $('.desktopsearch').addClass('hasval');
      }else{
        $('.desktopsearch').removeClass('hasval');
      }
      if(this.value.length<2){
        $('#livesearch_result').hide();

      }else{
        $('#livesearch_result').show();
        var data = '';
        jQuery.ajax({
          url: '/WebAjaxBase.php?Object=article@LiveArticleSearch&SearchParam='+encodeURIComponent($(this).val()),
          type: "post",
          dataType: "html",
          error: function(XMLHttpRequest, textStatus, errorThrown) {
            if (typeof(window.console) != "undefined") {
              window.console.log(XMLHttpRequest)
            }
          },
          success: function(html) {
            

            var count = 0; 
            if($(html).find('.LiveSearchNoArticleFoundHint').length){
              data +="<h5>Leider wurde zu Ihrer Suchanfrage kein passendes Ergebnis gefunden.</h5>";
              result=false;
            }else{  
              //search in each tabelrow    
              $(html).find('tr').each(function(){
                 if(count==0){
                   data +="<h3>Suchergebnisse:</h3>";
                 }else if(count<=5){
                   //Holt Artikelbild und Entfernt inlinestyles
                   var img = $(this).find('.LiveSearchImage').find('img').attr('style', '').addClass('img-responsive').parent().html();
                   //Platzhalter falls kein Bild vorhanden
                   if(typeof img == "undefined"){
                     img = '<i class="fa fa-picture-o" aria-hidden="true"></i>';
                   }
                   //verlinkt Bild
                   var link = $(this).find('.LiveSearchArticleName a').attr('href');

                   //Holt Artikel Name
                   var title = $(this).find('.LiveSearchArticleName').html();
                   //HTML Ausgabe bauen

                   data += '<div class="row mt-xs-20 search-products"><div class="col-xs-2"><a href="'+link+'">'+img+'</a></div><div class="col-xs-10 link">'+title+'</div></div>';
                 }
                 count++;
                 //first=false;
              });
              result=true;
            }
          },

          complete: function(html){
            $('#livesearch_result').empty();
            $('#livesearch_result').append(data);
            //catch empty results and redirekt to custom page
           
            //set custom button under result list 
            if(result){
              $('#livesearch_result').append('<div class="text-center mt-xs-25"><a id="showall" class="btn btn-default btn-block">Alle anzeigen</a></div>');
              $('#livesearch_result').find('#showall').click(function(e){
                e.preventDefault();
                $('#LiveSearch').closest('form').submit();
              });
            }
           
          }
        })
      }
    });

    //Livesearch
    $('#LiveSearchmobile').keyup(function(event) {
      if(this.value.length<2){
        $('#livesearchmobile_result').hide();
      }else{
        $('#livesearchmobile_result').show();
        var data = '';
        jQuery.ajax({
          url: '/WebAjaxBase.php?Object=article@LiveArticleSearch&SearchParam='+encodeURIComponent($(this).val()),
          type: "post",
          dataType: "html",
          error: function(XMLHttpRequest, textStatus, errorThrown) {
            if (typeof(window.console) != "undefined") {
              window.console.log(XMLHttpRequest)
            }
          },
          success: function(html) {
           
            var count = 0; 
            if($(html).find('.LiveSearchNoArticleFoundHint').length){
              data +="<h5>Leider wurde zu Ihrer Suchanfrage kein passendes Ergebnis gefunden.</h5>";
              result=false;
            }else{  
              //search in each tabelrow    
              $(html).find('tr').each(function(){
                 if(count==0){
                   data +="<h4>Suchergebnisse:</h4>";
                 }else if(count<=3){
                   //Holt Artikelbild und Entfernt inlinestyles
                   var img = $(this).find('.LiveSearchImage').find('img').attr('style', '').addClass('img-responsive').parent().html();
                   //Platzhalter falls kein Bild vorhanden
                   if(typeof img == "undefined"){
                     img = '<i class="fa fa-picture-o" aria-hidden="true"></i>';
                   }
                   //verlinkt Bild
                   var link = $(this).find('.LiveSearchArticleName a').attr('href');

                   //Holt Artikel Name
                   var title = $(this).find('.LiveSearchArticleName').html();
                   //HTML Ausgabe bauen

                   data += '<div class="row mt-xs-20 search-products"><div class="col-xs-2"><a href="'+link+'">'+img+'</a></div><div class="col-xs-10 link">'+title+'</div></div>';
                 }
                 count++;
                 //first=false;
              });
              result=true;
            }
          },

          complete: function(){
            $('#livesearchmobile_result').empty();
            $('#livesearchmobile_result').append(data);
           
            //set custom button under result list 
            if(result){
              $('#livesearchmobile_result').append('<div class="text-center mt-xs-15 mb-xs-15"><a id="showall" class="btn btn-default btn-block">Alle anzeigen</a></div>');
              $('#livesearchmobile_result').find('#showall').click(function(e){
                e.preventDefault();
                $('#LiveSearchmobile').closest('form').submit();
              });
            }
           

          }
        })
      }
    });
})
$(window).resize(function(event) {
  $("img").unveil(200, function() {
    $(this).load(function() {
      var classes = this.getAttribute('class');
      this.setAttribute("class", classes +' loaded');
    });
  });
});
$( ".btn-filter" ).click(function() {
  $('.filter-wrap').toggle("normal");
});
$( window ).resize(function() {
  if($(window).width() > 992) {
    $('.filter-wrap').show();
    $('.filter-wrap .panel-collapse').removeClass('in');
  }
});
$(document).ready(function() {
  $('.smooth-scroll').click(function(e) {
    e.preventDefault();
    var target=$(this).attr('href');
    $('html, body').animate({scrollTop: $(target).offset().top}, 2000);
  });
  if($(window).width() < 992) {
    $('.filter-wrap .panel-collapse').removeClass('in');
  }
});